import * as Sentry from "@sentry/nextjs";

export const setRequestIdTag = (requestId: string | null | undefined): void => {
  if (!requestId) {
    return;
  }
  Sentry.setTag("request_id", requestId);
};

export const setOrgIdTag = (orgId: string | null | undefined): void => {
  if (!orgId) {
    return;
  }
  Sentry.setTag("org_id", orgId);
};

export const clearOrgIdTag = (): void => {
  Sentry.setTag("org_id", "");
};
